import { combineReducers } from "@reduxjs/toolkit";
import {
  createCourseReducer,
  editingCourseReducer,
  getAllCourseReducer,
  getCourseLearningReducer,
  getDetailsCourseReducer,
  deleteCourseReducer,
  addLectureReducer,
  getDetailsCourseForUpdateReducer,
  updateCourseReducer,
  updateLectureReducer,
  exploreCourseReducer,
  getSavedCoursesReducer,
  saveCourseReducer,
  deleteSavedCourseReducer,
  markLessonCompletedReducer,
  getAllCourseByInstructorReducer,
  getNewestCoursesReducer,
  getHighestRatedCoursesReducer,
  checkSavedCourseReducer,
  changeCourseStatusReducer,
  getAllMyLearningReducer,
} from "./slices";
import { addAssignmentReducer } from "./slices/addAssignment";

const courseReducer = combineReducers({
  editingCourse: editingCourseReducer,
  allCourse: getAllCourseReducer,
  exploreCourse: exploreCourseReducer,
  createCourse: createCourseReducer,
  addLecture: addLectureReducer,
  deleteCourse: deleteCourseReducer,
  getDetailsCourse: getDetailsCourseReducer,
  getCourseLearning: getCourseLearningReducer,
  getDetailsCourseForUpdate: getDetailsCourseForUpdateReducer,
  newestCourses: getNewestCoursesReducer,
  highestRatedCourses: getHighestRatedCoursesReducer,
  updateCourse: updateCourseReducer,
  updateLecture: updateLectureReducer,
  getSavedCourses: getSavedCoursesReducer,
  saveCourse: saveCourseReducer,
  deleteSavedCourse: deleteSavedCourseReducer,
  markLectureCompleted: markLessonCompletedReducer,
  getAllCourseByInstructor: getAllCourseByInstructorReducer,
  checkSavedCourse: checkSavedCourseReducer,
  courseStatusChanger: changeCourseStatusReducer,
  getAllMyLearning: getAllMyLearningReducer,
  addAssignment: addAssignmentReducer,
});

export default courseReducer;
